import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { initGA4 } from "./lib/ga4";

// Initialize Google Analytics 4 (consent defaults already set in index.html BEFORE gtag.js loads)
initGA4();

createRoot(document.getElementById("root")!).render(<App />);
